import {LOGOUT_USER, SET_USER, removeToken, setToken} from "../actions/user";

const initialState = {
    // id : null,
    firstName : null,
    lastName : null,
    email : null,
    hashCode : null,
    cellPhone : null,
    gender : null,
    level : null,
    score : null,
    referredNo : null,
    city : null,
    apiToken : null,
    pic: null,
    reagent:null,
    address:null,
    postCode:null,
};

export default function user(state = initialState , action = {}) {
    switch (action.type) {
        case SET_USER :
            const { user } = action;
            setToken(user.api_token);

            return {
                // id: user.id,
                firstName : user.firstname,
                lastName : user.lastname,
                email : user.email,
                hashCode : user.hash_code,
                cellPhone : user.cell_phone,
                gender : user.gender,
                level : user.level,
                score : user.score,
                referredNo : user.referred_no,
                city : null,
                apiToken: user.api_token,
                pic: user.pic,
                reagent: user.reagent,
                address: user.address,
                postCode: user.postal_code,
            };
        case LOGOUT_USER :
            // localStorage.removeItem(API_TOKEN);
            removeToken();
            return {id : null,
                firstName : null,
                lastName : null,
                email : null,
                hashCode : null,
                cellPhone : null,
                gender : null,
                level : null,
                score : null,
                city : null,
                apiToken : null,
                pic: null,
                reagent:null,
                referredNo : null,
                address : null,
                postCode : null,
            };
            // break;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/userReducer.js